<template>
  <div class="position-relative">
    <div v-if="modelValue" class="form-control d-flex justify-content-between align-items-center">
      <span><strong>{{ modelValue.nomComplet }}</strong> <small class="text-muted">{{ modelValue.numeroDossier }} {{ modelValue.telephone || modelValue.telephoneContact }}<span v-if="modelValue.ageAffiche"> · {{ modelValue.ageAffiche }}</span></small></span>
      <button type="button" class="btn-close btn-sm" @click="$emit('update:modelValue', null)"></button>
    </div>
    <template v-else>
      <input v-model="q" class="form-control" :placeholder="placeholder" @input="chercher" @focus="ouvert = true" @blur="fermerPlusTard">
      <ul v-if="ouvert && (resultats.length || q.length >= 2)" class="list-group position-absolute w-100 shadow-sm choix-liste">
        <li v-for="p in resultats" :key="p.id" class="list-group-item list-group-item-action" @mousedown.prevent="choisir(p)">
          <strong>{{ p.nomComplet }}</strong>
          <small class="text-muted ms-2">{{ p.numeroDossier }}<span v-if="p.telephone || p.telephoneContact"> · {{ p.telephone || p.telephoneContact }}</span> <span v-if="p.dateNaissance">· né(e) le {{ date(p.dateNaissance) }}</span><span v-if="p.ageAffiche"> ({{ p.ageAffiche }})</span></small>
          <div v-if="p.responsable" class="small text-info-emphasis"><i class="bi bi-people me-1"></i>{{ p.responsable }}</div>
        </li>
        <li v-if="!chargement && q.length >= 2 && resultats.length === 0" class="list-group-item text-muted small">Aucun patient trouvé.</li>
      </ul>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import dayjs from 'dayjs'

export default {
  name: 'ChoixPatient',
  props: { modelValue: { type: Object, default: null }, placeholder: { type: String, default: 'Nom, n° de dossier ou téléphone…' } },
  emits: ['update:modelValue'],
  data() {
    return { q: '', resultats: [], ouvert: false, chargement: false, minuteur: null }
  },
  methods: {
    chercher() {
      clearTimeout(this.minuteur)
      if (this.q.length < 2) {
        this.resultats = []
        return
      }
      this.minuteur = setTimeout(async () => {
        this.chargement = true
        try {
          this.resultats = (await api.custom(`patients/recherche?q=${encodeURIComponent(this.q)}`, 'GET')).data.data
        } finally {
          this.chargement = false
        }
      }, 250)
    },
    choisir(p) {
      this.$emit('update:modelValue', p)
      this.q = ''
      this.resultats = []
      this.ouvert = false
    },
    fermerPlusTard() {
      setTimeout(() => { this.ouvert = false }, 150)
    },
    date(d) {
      return dayjs(d).format('DD/MM/YYYY')
    }
  }
}
</script>

<style scoped>
.choix-liste { z-index: 20; max-height: 280px; overflow-y: auto; }
</style>
